import React from 'react';
import { Tooltip } from 'react-tooltip';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Skills.scss';
import { skills } from '../../constants/skills';
import { experience } from '../../constants/experience';

const Skills = () => {
  return (
    <>
      <h1 className='head-text'>Skills & Experience</h1>

      <div className='app__skills-container'>
        <motion.div className='app__skills-list'>
          {skills?.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className='app__skills-item app__flex'
              key={skill.title}
            >
              <div className='app__flex' style={{ backgroundColor: '#EDF2F8' }} key={skill.title}
              >
                <img src={skill.image} alt={skill.title} />
              </div>
              <p className='p-text'>{skill.title}</p>
            </motion.div>
          ))}
        </motion.div>
        <motion.div className='app__skills-exp'>
          {experience?.map((experience) => (
            <motion.div className='app__skills-exp-item' key={experience.year}>
              <div className='app__skills-exp-year'>
                <p className='bold-text'>{experience.year}</p>
              </div>
              <motion.div className='app__skills-exp-works'>
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className='app__skills-exp-work'
                      data-tooltip-content={work.desc}
                      data-tooltip-id={work.name}
                      key={work.company}
                    >
                      <h4 className='bold-text'>{work.name}</h4>
                      <p className='p-text'>{work.company}</p>
                    </motion.div>
                    <Tooltip
                      id={work.name}
                      // effect="solid"
                      arrowColor='#fff'
                      className='skills-tooltip'
                    />
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </>
  ); 
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg'
);
